
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.446 12.587"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"squares-stack(1)"}},[_c('g',{attrs:{"data-name":"Group 867"}},[_c('path',{attrs:{"data-name":"Path 7054","d":"M.384 4.472l5.7 2.564a1.215 1.215 0 001.268 0l5.7-2.564a.786.786 0 000-1.266L7.352.194a1.132 1.132 0 00-1.268 0l-5.7 3.012a.771.771 0 000 1.266zm0 2.686l5.7 2.564a1.215 1.215 0 001.268 0l5.7-2.564c.282-.131.385-.748.385-1.081-.367.184-.886.445-.9.448L6.723 9.211.9 6.525c.02.012-.516-.23-.9-.448 0 .325.082.921.384 1.081zm6.338 4.739L.9 9.211c.02.012-.516-.23-.9-.447 0 .325.082.92.384 1.081l5.7 2.564a1.215 1.215 0 001.268 0l5.7-2.564c.282-.131.385-.748.385-1.081-.367.184-.886.445-.9.447z","fill":"#1c1c1c"}})])])])
          )
        }
      }
    